import type { ComponentSchema, FieldSchema } from '../../../../../schema-types'
import { schema as shared } from '../../../../lightings/lightings-1/sections/footer/footer.schema'

const SOCIAL_PLATFORMS = ['facebook', 'instagram', 'youtube', 'tiktok', 'linkedin', 'x']
  .map(value => ({ label: value === 'x' ? 'X' : value[0]!.toUpperCase() + value.slice(1), value }))

/** The newsletter beside the logo at the top of the plum footer. */
const NEWSLETTER_FIELDS: FieldSchema[] = [
  { key: 'newsletterTitle', label: 'Newsletter title', type: 'localized-string', default: 'Join the playroom club' },
  { key: 'newsletterText', label: 'Newsletter offer line', type: 'localized-string', default: 'New toys, back-to-school picks and offers, first.' },
  {
    key: 'newsletterAction',
    label: 'Sign-up form link',
    type: 'string',
    placeholder: 'https://…',
    help: 'The email field posts to this form (e.g. your mailing-list sign-up form). Empty = a "Get offers on WhatsApp" button.',
  },
]

/**
 * Khelaghor footer: the shared footer fields (stored data stays portable) with the platforms its icons
 * support, plus the newsletter. Phone, email and address fall back to Store info.
 */
export const schema: ComponentSchema = {
  ...shared,
  label: 'Footer',
  description: 'Plum band: logo and newsletter, contact details, link columns, top categories, social icons and payment methods.',
  variants: [{ id: 'v1', label: 'Plum band' }],
  commonFields: [
    ...NEWSLETTER_FIELDS,
    ...shared.commonFields
      .filter(f => f.key !== 'title')
      .map((f): FieldSchema => (f.key !== 'socialLinks'
        ? f
        : { ...f, itemSchema: f.itemSchema?.map(i => (i.key === 'platform' ? { ...i, options: SOCIAL_PLATFORMS } : i)) })),
  ],
}
